const n = {
  name: "ExternalLink",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00015 5H19.0002V16H17.0002V8.41421L6.00015 19.4142L4.58594 18L15.5859 7H8.00015V5Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ExternalLink
};
